"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("@tanstack/react-query");
const useLocations = () => {
    const fetchFunc = () => axios.post('/api/booking/get-locations').then((response) => response.data.data);
    return (0, react_query_1.useQuery)({ queryKey: ['get-locations'], queryFn: fetchFunc });
};
exports.default = useLocations;
